import React, { FC, HTMLAttributes } from 'react';
import TableHeadItem from "./TableHeadItem";
import TableRow from "./TableRow";
import classNames from 'classnames';
import css from './Table.module.scss';

const cx = classNames.bind(css)

interface TableProps extends HTMLAttributes<HTMLTableElement> {
    theadData: string[];
    tbodyData: ITBodyData[];
    customClass?: string;
}

interface ITBodyData {
    id: string | number;
    items: string[];
    onClickRow?: () => void;
}

const Table: FC<TableProps> = ({ theadData, tbodyData, customClass }) => {
    return (
        <table className={ cx(css.table, customClass) }>
            <thead>
            <tr>
                { theadData.map((h) => <TableHeadItem key={ h } item={ h }/>) }
            </tr>
            </thead>
            <tbody>
            { tbodyData.map((item) => {
                return (
                    <TableRow
                        key={ item.id }
                        data={ item.items }
                        onClickRow={ item.onClickRow }
                    />
                )
            }) }
            </tbody>
        </table>
    );
};

export default Table;